
/**
 * Hủy lan rộng event
 * HTHIEP 09.02.2022
 */
const cancelEvent = (e) => {
  if (e) {
    if (typeof e.preventDefault === 'function') {
      e.preventDefault()
    }

    if (typeof e.stopPropagation === 'function') {
      e.stopPropagation()
    }

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation()
    }
  }
}

export {
  cancelEvent,
}
